import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import nbqEcharts from "./nbqEcharts";
export default {
  name: "realtimedata",
  data: function data() {
    return {
      bats: ["BAT1", "BAT2", "BAT3"],
      selected: 0,
      // 默认选中 BAT1
      selectedMonth: this.getCurrentMonth()
    };
  },
  components: {
    nbqEcharts: nbqEcharts
  },
  methods: {
    getCurrentMonth: function getCurrentMonth() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1; // 获取当前月份，注意要加1

      return "".concat(year, "-").concat(month < 10 ? "0" + month : month); // 格式化为 "YYYY-MM"
    },
    selectBat: function selectBat(index) {
      this.selected = index; // 更新选中的索引
    },
    getImageSrc: function getImageSrc(value) {
      if (value >= 0 && value <= 10) {
        return require("@/assets/images/lowD.png");
      } else if (value >= 11 && value <= 30) {
        return require("@/assets/images/centerD.png");
      } else if (value >= 31 && value <= 60) {
        return require("@/assets/images/heightD.png");
      } else if (value >= 61 && value <= 100) {
        return require("@/assets/images/fullD.png");
      }

      return ""; // 默认值
    }
  },
  mounted: function mounted() {
    console.log('selectedMonth', this.selectedMonth);
  }
};